import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

import Button from '@material-ui/core/Button'

import Paper from '@material-ui/core/Paper'

import PrintIcon from '@material-ui/icons/Print'

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <ReportDialog show onSaveReport = {report} onCancel = {} />
 */

class ReportDialog extends Component {

	state = {
		report: "",
		notIssuedList: true,
		notReceivedList: false,
		completedList: false,
	}

	formatShowTime(date) {
		let t = (date.split(" ")[1]).split(":")
		return `${t[0]}:${t[1]}`
	}

	formatShowDate(date) {

		const monthNames = [
			"января",
			"февраля",
			"марта",
			"апреля",
			"мая",
			"июня",
			"июля",
			"августа",
			"сентября",
			"октября",
			"ноября",
			"декабря",
		]

		let spDate = (date.split(" ")[0]).split("-")
		let monthNumber = parseInt(spDate[1]) - 1

		return `${spDate[2]} ${monthNames[monthNumber]}`

	}

	generateReport(show) {

		let report = [
			`<p>Название шоу: <strong>"${this.props.show.name}"</strong></p>`,
			`<p>Дата проведения: <strong>${this.formatShowDate(this.props.show.date)}</strong></p>`,
			`<p>Адрес: <strong>${this.props.show.address}</strong></p>`,
			`<p>Время проведения: <strong>${this.formatShowTime(this.props.show.date)}</strong></p>`,

			`<p>Коробка большая: <strong>${this.props.show.boxBig}</strong></p>`,
			// `<p>Коробка средняя: <strong>${this.props.show.boxMedium}</strong></p>`,

			`<p>Ведущий(ие): <strong>${this.props.show.artists.map(artist => artist.name).join(", ")}</strong></p>`,
			"<hr>",
		]

		if (this.state.notIssuedList) {
			let notIssued = this.props.show.items.filter(item => item.issued == "0" && item.received == "0")
			if (notIssued.length) {
				report.push("<p>Не выданные</p>")
				report.push('<table cellpadding = "5" style = "width: 100%; border-collapse: collapse;  border: 1px solid black">')
				report = report.concat(notIssued.map(item => `<tr style = "border: 1px solid black"><td>${item.name}</td><td width="50px" align="right">${item.amount}</td></tr>`))
				report.push('</table>')
			}
		}

		if (this.state.notReceivedList) {
			let notReceived = this.props.show.items.filter(item => item.issued == "1" && item.received == "0")
			if (notReceived.length) {
				report.push("<p>Не полученные</p>")
				report.push('<table cellpadding = "5" style = "width: 100%; border-collapse: collapse;  border: 1px solid black">')
				report = report.concat(notReceived.map(item => `<tr style = "border: 1px solid black"><td>${item.name}</td><td width="50px" align="right">${item.amount}</td></tr>`))
				report.push('</table>')
			}
		}

		if (this.state.completedList) {
			let completed = this.props.show.items.filter(item => item.issued == "1" && item.received == "1")
			if (completed.length) {
				report.push("<p>Завершеные</p>")
				report.push('<table cellpadding = "5" style = "width: 100%; border-collapse: collapse;  border: 1px solid black">')
				report = report.concat(completed.map(item => `<tr style = "border: 1px solid black"><td>${item.name}</td><td width="50px" align="right">${item.amount}</td></tr>`))
				report.push('</table>')
			}
		}

		report = report.concat([
			`<p>Комментарий:</p>`,
			`<div style = "padding: 10px; border: 1px solid #000; white-space: pre-wrap">${this.props.show.comment}</div>`,
		])

		return report.join("\n")

	}

	render() {

		let report = this.generateReport(this.props.show)

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Отчет о шоу
			</DialogTitle>


			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				Показать предметы

				<React.Fragment>

					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.notIssuedList}
								onChange={e => {
									this.setState({
										notIssuedList: !this.state.notIssuedList
									})
								}}
							/>
						}
						label="Не выданные"
					/>

					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.notReceivedList}
								onChange={e => {
									this.setState({
										notReceivedList: !this.state.notReceivedList
									})
								}}
							/>
						}
						label="Не полученные"
					/>

					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.completedList}
								onChange={e => {
									this.setState({
										completedList: !this.state.completedList
									})
								}}
							/>
						}
						label="Завершенные"
					/>

				</React.Fragment>

				<Paper className = {this.props.classes.paper}>
					<div dangerouslySetInnerHTML = {{ __html: report}}/>
				</Paper>

			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onPrintReport === "function") {
							this.props.onPrintReport(report)
						}
					}}
				><PrintIcon style = {{marginRight: "4px"}}/> Напечатать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSaveReport === "function") {
							this.props.onSaveReport(report)
						}
					}}
				>Сохранить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default withStyles(theme => ({
	paper: {
		padding: theme.spacing.unit,
	},
}))(ReportDialog)
